import api from './api';
import { Document, DocumentFormData, ApiResponse } from '../../types/document.types';

export const documentsService = {
  getAll: async (): Promise<ApiResponse<Document[]>> => {
    const response = await api.get<ApiResponse<Document[]>>('/api/documents');
    return response.data;
  },

  getById: async (id: number): Promise<ApiResponse<Document>> => {
    const response = await api.get<ApiResponse<Document>>(`/api/documents/${id}`);
    return response.data;
  },

  create: async (data: DocumentFormData): Promise<ApiResponse<Document>> => {
    const response = await api.post<ApiResponse<Document>>('/api/documents', data);
    return response.data;
  },

  update: async (id: number, data: DocumentFormData): Promise<ApiResponse<Document>> => {
    const response = await api.put<ApiResponse<Document>>(`/api/documents/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/api/documents/${id}`);
    return response.data;
  },

  uploadFile: async (file: File): Promise<ApiResponse<{ url: string; filename: string }>> => {
    const fd = new FormData();
    fd.append('document', file);
    const response = await api.post<ApiResponse<{ url: string; filename: string }>>('/api/documents/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
